<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    <ng-container *ngIf="isView">View Template</ng-container>
    <ng-container *ngIf="isEdit">Edit Template</ng-container>
    <ng-container *ngIf="isCreate">Create New Template</ng-container>
  </div>
  <div class="header-right">
    <button
      *ngIf="isCreate"
      mat-button
      color="lightGreen"
      (click)="saveTemplate()"
      [disabled]="saveDisabled"
    >
      Save Template
    </button>
    <button
      *ngIf="isEdit"
      mat-button
      color="lightGreen"
      (click)="updateTemplate()"
      [disabled]="saveDisabled"
    >
      Update Template
    </button>
  </div>
</div>
<div class="template">
  <div class="template-columns">
    <div class="template-column">
      <div class="container template-info-container">
        <div class="container-content">
          <lhpe-select
            controlName="templateType"
            placeholder="Template type"
            [formGroup]="templateForm!"
            [required]="true"
            [options]="templateTypeOptions"
          >
          </lhpe-select>
          <lhpe-input
            controlName="templateName"
            placeholder="Template name"
            [formGroup]="templateForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>
      </div>
      <ng-container *ngIf="isMobilePush && !isView">
        <div class="container header-image-container">
          <div
            class="container-header no-bottom-border"
            (click)="toggleHeaderImages()"
          >
            <div class="text">Header images</div>
            <svg-icon
              *ngIf="!headerOpened"
              src="assets/svg/arrow-right.svg"
              [svgStyle]="{
                'width.px': '7',
                'height.px': '12'
              }"
              svgClass="grey"
            ></svg-icon>
            <svg-icon
              *ngIf="headerOpened"
              src="assets/svg/arrow-down.svg"
              [svgStyle]="{
                'width.px': '12',
                'height.px': '7'
              }"
              svgClass="grey"
            ></svg-icon>
          </div>
          <div
            *ngIf="headerOpened"
            class="container-content"
            id="availableHeaderImages"
            cdkDropList
            [cdkDropListData]="headerImages"
            cdkDropListConnectedTo="headerPreviewContainer"
            (cdkDropListDropped)="onDrop($event)"
          >
            <img
              *ngFor="let headerImage of headerImages"
              [src]="headerImage.url"
              cdkDrag
              [cdkDragData]="headerImage"
              class="image"
            />
          </div>
        </div>
        <div class="container background-image-container">
          <div
            class="container-header no-bottom-border"
            (click)="toggleBackgroundImages()"
          >
            <div class="text">Background images</div>
            <svg-icon
              *ngIf="!backgroundOpened"
              src="assets/svg/arrow-right.svg"
              [svgStyle]="{
                'width.px': '7',
                'height.px': '12'
              }"
              svgClass="grey"
            ></svg-icon>
            <svg-icon
              *ngIf="backgroundOpened"
              src="assets/svg/arrow-down.svg"
              [svgStyle]="{
                'width.px': '12',
                'height.px': '7'
              }"
              svgClass="grey"
            ></svg-icon>
          </div>
          <div
            *ngIf="backgroundOpened"
            class="container-content"
            id="availableBackgroundImages"
            cdkDropList
            [cdkDropListData]="backgroundImages"
            cdkDropListConnectedTo="backgroundPreviewContainer"
            (cdkDropListDropped)="onDrop($event)"
          >
            <img
              *ngFor="let backgroundImage of backgroundImages"
              [src]="backgroundImage.url"
              cdkDrag
              [cdkDragData]="backgroundImage"
              class="image"
            />
          </div>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="isMobilePush">
      <div class="template-column phone-column">
        <div class="phone">
          <div class="phone-containers">
            <div class="image-header">
              <div *ngIf="!selectedHeadingImage.length" class="text">
                Drag and drop header image here
              </div>
              <img
                *ngIf="selectedHeadingImage.length"
                [src]="selectedHeadingImage[0].url"
              />
            </div>
            <div class="divider"></div>
            <div
              class="image-background"
              [ngClass]="{ 'bottom-bar-open': showThumbs || redemptionCode }"
            >
              <div *ngIf="!selectedBgImage.length" class="text">
                Drag and drop BG image here
              </div>
              <img
                *ngIf="selectedBgImage.length"
                [src]="selectedBgImage[0].url"
              />
            </div>
          </div>

          <!--
          <svg-icon
            class="iphone-preview"
            src="assets/svg/IPhone_X_vector.svg"
            [svgStyle]="{
              'width.px': '360',
              'height.px': '722'
            }"
          >
          </svg-icon>
          -->
          <img class="iphone-preview" src="assets/png/iphone-display.png" width="360" height="722" />

          <div class="drag-overlay">
            <div
              class="image-header"
              id="headerPreviewContainer"
              cdkDropList
              [cdkDropListData]="selectedHeadingImage"
              cdkDropListConnectedTo="availableHeaderImages"
              (cdkDropListDropped)="onDrop($event)"
            ></div>
            <div class="divider"></div>
            <div
              class="image-background"
              id="backgroundPreviewContainer"
              class="image-background"
              cdkDropList
              [cdkDropListData]="selectedBgImage"
              cdkDropListConnectedTo="availableBackgroundImages"
              (cdkDropListDropped)="onDrop($event)"
            >
              <div
                class="text"
                [ngClass]="{
                  'no-bottom-bar': !(showThumbs || redemptionCode),
                  'show-text': showText
                }"
              >
                <ng-container *ngIf="showText">
                  <p class="heading">Hello Jane!</p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    sit amet arcu vel metus finibus gravida. Duis felis quam,
                    lobortis sed nulla et, aliquet venenatis lorem. Morbi
                    placerat lorem ut sem aliquam tempor. Cras mi diam,
                    elementum sed elementum non, porta eget dolor. In semper
                    varius metus in interdum.
                  </p>

                  <p>
                    Cras id cursus nibh, vehicula hendrerit libero. Donec
                    placerat ornare magna vel rhoncus. Pellentesque tincidunt
                    ipsum non faucibus vulputate. In sed leo vel massa porta
                    cursus nec eget turpis. Sed et purus quis mauris dignissim
                    tempor nec eget ligula.
                  </p>
                </ng-container>
              </div>
              <div
                *ngIf="showThumbs || redemptionCode"
                class="bottom-bar"
                [ngStyle]="{ 'background-color': selectedThumbColor }"
              >
                <div *ngIf="redemptionCode" class="redemption">
                  <svg-icon src="assets/svg/qr-code.svg"></svg-icon>
                </div>
                <div *ngIf="showThumbs" class="thumbs">
                  <svg-icon src="assets/svg/thumbs-up-circle.svg"></svg-icon>
                  <svg-icon src="assets/svg/thumbs-down-circle.svg"></svg-icon>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!isView" class="delete-buttons-overlay">
            <div class="image-header">
              <button
                *ngIf="selectedHeadingImage.length"
                mat-button
                (click)="removeHeading()"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '22.5',
                    'height.px': '22.298'
                  }"
                  svgClass="white"
                ></svg-icon>
              </button>
            </div>

            <div class="image-background">
              <button
                *ngIf="selectedBgImage.length"
                mat-button
                (click)="removeBackground()"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '22.5',
                    'height.px': '22.298'
                  }"
                  svgClass="white"
                ></svg-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="selectedBgImage.length" class="template-column">
        <div class="container options-container">
          <div class="container-content">
            <div class="option">
              <div class="label">Sample text</div>
              <mat-slide-toggle color="lightGreen" [(ngModel)]="sampleText">
                {{ sampleText ? "On" : "Off" }}
              </mat-slide-toggle>
            </div>

            <div class="option">
              <div class="label">Redemption code</div>
              <mat-slide-toggle color="lightGreen" [(ngModel)]="redemptionCode">
                {{ redemptionCode ? "On" : "Off" }}
              </mat-slide-toggle>
            </div>

            <div *ngIf="!isView" class="option">
              <div class="label" A>Thumbs up/down interaction</div>
              <mat-slide-toggle color="lightGreen" [(ngModel)]="thumbs">
                {{ thumbs ? "On" : "Off" }}
              </mat-slide-toggle>
            </div>
            <div
              *ngIf="(showThumbs || redemptionCode) && !isView"
              class="option"
            >
              <div class="label">Footer BG color</div>
              <div class="color-options">
                <div class="colors">
                  <div
                    *ngFor="let color of thumbsColors"
                    class="color"
                    [ngClass]="{ selected: selectedThumbColor === color }"
                    [ngStyle]="{ 'background-color': color }"
                    (click)="setThumbColor(color)"
                  ></div>
                  <button
                    mat-button
                    class="icon-btn add-color-btn"
                    [(colorPicker)]="colorPickerColor"
                    [cpOKButton]="true"
                    cpOKButtonText="Add Color"
                    [cpCancelButton]="true"
                    (colorPickerSelect)="onColorPickerOK()"
                  >
                    <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
